import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../../api';
import { ConfirmOTPRequest } from './confirmotprequest';

export class ConfirmOTPAPI extends APIImpl<ConfirmOTPRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/confirm-otp
        return "confirm-otp";
    }
    
    getRequestData()
    {
        return "msisdn=" + this.getRequest().getConfirmOTPRequest().getMsisdn() +"&"+
               "language="+ this.getContext().getUserContext().getLanguage()+"&"+
                 "otp="+ this.getRequest().getConfirmOTPRequest().getOtp();
             
            //    "secToc="+ this.getRequest().getOTPCheckRequest().getSecToc()+"&"+
            //    "type="+ this.getRequest().getOTPCheckRequest().getType();
    }

    getHttpHeaders():string
    {
       let baseHeaders = super.getHttpHeaders();
       let combinedHeaders : any;

           let editProfileHeaderForProfilePic = {
            "content-type" : 'application/x-www-form-urlencoded'
           } as any; 
           combinedHeaders = Object.assign(editProfileHeaderForProfilePic, baseHeaders);
           return combinedHeaders;
      
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/confirmotp/confirmotpapi.tsx